import { render } from "./SpellWord.vue?vue&type=template&id=23de4716&scoped=true"
const script = {}

import "./SpellWord.vue?vue&type=style&index=0&id=23de4716&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23de4716"]])

export default __exports__